import React, { useEffect, useRef, useState } from 'react'
import { DownloadLinks, ProductsModel } from './models/PortfolioProductsModel'
import {
    View,
    Text,
    useWindowDimensions,
    Animated,
    NativeSyntheticEvent,
    NativeScrollEvent,
    TouchableOpacity,
    StyleSheet,
} from 'react-native'
import { Feather, Ionicons } from '@expo/vector-icons'
import MediaComponent from '../customUtils/Components/MediaComponent'
import { FlatList, ScrollView } from 'react-native-gesture-handler'
import { Platform } from 'react-native'
import BottomSheet from '../BottomSheetWrapper'
import { StackScreenProps } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import styles from './PortfolioProductDetailStyles'
import { TrackingServices } from '../../../database/tracking.database'

import theme from '../../../theme'
import { useNavigation } from '@react-navigation/native'

import { shareAsync } from 'expo-sharing'
import { Loader } from '../customUtils/Components/Loader'

import { downloadPdf } from '../../utils/functions.utils'
import { getLanguage } from '../appBar/context/LocalizationContext'
import Constants from 'expo-constants'
import {
    useBreakpoint,
    useDimensionsStore,
} from '../../redux/zustand/useDimensionStore'
import { ImageWithZoom } from '../customUtils/Components/ImageWIthZoom'

import { Image } from 'expo-image'
import { Bullets } from '../../../src/components/customUtils/Components/Bullets'
interface Props extends StackScreenProps<DotsNavigation, 'PortfolioProductDetail'> {}

const isWeb = Platform.OS === 'web'
export const PortfolioProductDetail = ({ route }: Props) => {
    //  const [product, setData] = useState<ProductsModel>()

    const product = route.params.data
    useEffect(() => {
        // Inicia la pantalla aquí
        // setData(data)
    }, [])

    return <ProductDetail product={product} />
}
export default PortfolioProductDetail

export const ProductDetail = ({ product }: { product: ProductsModel }) => {
    const scrollX = useRef(new Animated.Value(0)).current

    const width = useDimensionsStore((state) => state.width)

    const { languageFile } = getLanguage()
    const [isLoading, setisLoading] = useState(false)
    TrackingServices.addTracking(
        product._id,
        'ecommerce_products',
        'ecommerce_products',
    )

    const activeLoader = (value: boolean) => {
        setisLoading(value)
    }

    const expoConfig = Constants.expoConfig || { slug: '' }
    const getEanText = (slug: string) => {
        switch (slug) {
            case 'one-mitsubishi':
                return 'Slogan: '
            case 'one-pfizer':
                return 'Presentación: '
            default:
                return 'EAN: '
        }
    }
    const getSkuPrefix = (slug: string) => {
        switch (slug) {
            case 'one-mitsubishi':
                return 'Precio: '
            default:
                return 'SKU: '
        }
    }
    const bp = useBreakpoint()
    const smallWindow = bp === 'sm'
    const eanPrefix = getEanText(expoConfig.slug)
    const skuPrefix = getSkuPrefix(expoConfig.slug)
    const verticalInfo = expoConfig.slug === 'one-mitsubishi' ? true : false
    // const verticalHeader = smallWindow || (product.description_short?.length ?? 0) <= 60 ? true : false
    const verticalHeader = true
    const setContentWidth = () => {
        let contentWidth = width
        if (!isWeb || smallWindow) {
            contentWidth = width
        } else {
            contentWidth = 300
        }
        return { contentWidth: contentWidth }
    }
    const { contentWidth } = setContentWidth()

    const flatListRef = useRef(null)
    const [currentIndex, setCurrentIndex] = useState(0)
    const [atEnd, setAtEnd] = useState(false)
    const [atStart, setAtStart] = useState(true)
    const scrollOffset = useRef(0)

    const onScroll = Animated.event(
        [{ nativeEvent: { contentOffset: { x: scrollX } } }],
        {
            useNativeDriver: false,
            listener: (e: NativeSyntheticEvent<NativeScrollEvent>) => {
                const { contentOffset, contentSize, layoutMeasurement } =
                    e.nativeEvent

                // Guardamos el offset actual
                scrollOffset.current = contentOffset.x

                // Detecta índice actual aproximado
                const index = Math.round(contentOffset.x / contentWidth)
                setCurrentIndex(index)

                // Detecta inicio/fin con tolerancia
                setAtStart(contentOffset.x <= 5)
                setAtEnd(
                    contentOffset.x + layoutMeasurement.width >=
                        contentSize.width - 5,
                )
            },
        },
    )
    const moveCarrousell = (forward = false) => {
        if (!flatListRef.current || !product.medias) return

        const newIndex = forward
            ? Math.min(currentIndex + 1, product.medias.length - 1)
            : Math.max(currentIndex - 1, 0)

        // setCurrentIndex(newIndex)

        const newOffset = newIndex * contentWidth

        flatListRef.current.scrollToOffset({
            offset: newOffset,
            animated: true,
        })
    }
    // ...existing code...
    // useEffect(() => {
    //     if (!(scrollX instanceof Animated.Value)) return

    //     const id = scrollX.addListener(({ value }) => {
    //         const index = Math.round(value / contentWidth)
    //         setCurrentIndex(index)
    //     })

    //     return () => {
    //         scrollX.removeListener(id)
    //     }
    // }, [scrollX])

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <View style={styles.container}>
                        <ScrollView showsVerticalScrollIndicator={false}>
                            <View
                                style={[
                                    {
                                        flex: 1,
                                        flexDirection: !smallWindow
                                            ? 'row'
                                            : 'column',
                                    },
                                    !smallWindow && {
                                        paddingHorizontal: 52,
                                        paddingTop: 10,
                                    },
                                ]}
                            >
                                <View>
                                    <View
                                        style={[
                                            {
                                                flexDirection: verticalHeader
                                                    ? 'column'
                                                    : 'row',
                                            },
                                            !smallWindow &&
                                                verticalHeader && {
                                                    alignItems: 'center',
                                                },
                                        ]}
                                    >
                                        {product.medias &&
                                            product.medias.length > 0 && (
                                                <View
                                                    style={[
                                                        !smallWindow && {
                                                            marginBottom: 15,
                                                        },
                                                    ]}
                                                >
                                                    <View
                                                        style={{
                                                            width: contentWidth,
                                                            height: contentWidth,
                                                            overflow: 'hidden',
                                                        }}
                                                    >
                                                        <Animated.FlatList
                                                            horizontal={true}
                                                            ref={flatListRef}
                                                            showsHorizontalScrollIndicator={
                                                                false
                                                            }
                                                            pagingEnabled
                                                            onScroll={onScroll}
                                                            data={product.medias}
                                                            keyExtractor={(
                                                                item,
                                                                index,
                                                            ) => index.toString()}
                                                            renderItem={({
                                                                item,
                                                            }) => {
                                                                return (
                                                                    <Image
                                                                        source={{
                                                                            uri: item.media_url,
                                                                        }}
                                                                        style={[
                                                                            {
                                                                                width: contentWidth,
                                                                                maxWidth:
                                                                                    '100%',
                                                                                aspectRatio: 1,
                                                                                resizeMode:
                                                                                    'contain',
                                                                            },
                                                                        ]}
                                                                    />
                                                                )
                                                            }}
                                                        />
                                                        {isWeb &&
                                                            product.medias.length >
                                                                1 && (
                                                                <>
                                                                    {/* Flecha izquierda */}
                                                                    {!atStart && (
                                                                        <TouchableOpacity
                                                                            onPress={() =>
                                                                                moveCarrousell(
                                                                                    false,
                                                                                )
                                                                            }
                                                                            style={[
                                                                                arrowStyle.arrowButton,
                                                                                {
                                                                                    left: 8,
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Ionicons
                                                                                name='chevron-back'
                                                                                size={
                                                                                    24
                                                                                }
                                                                                color='white'
                                                                            />
                                                                        </TouchableOpacity>
                                                                    )}

                                                                    {/* Flecha derecha */}
                                                                    {!atEnd && (
                                                                        <TouchableOpacity
                                                                            onPress={() =>
                                                                                moveCarrousell(
                                                                                    true,
                                                                                )
                                                                            }
                                                                            style={[
                                                                                arrowStyle.arrowButton,
                                                                                {
                                                                                    right: 8,
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Ionicons
                                                                                name='chevron-forward'
                                                                                size={
                                                                                    24
                                                                                }
                                                                                color='white'
                                                                            />
                                                                        </TouchableOpacity>
                                                                    )}
                                                                </>
                                                            )}
                                                    </View>
                                                    {product.medias.length > 1 && (
                                                        <Bullets
                                                            bullets={
                                                                product.medias.length
                                                            }
                                                            currentIndex={
                                                                currentIndex
                                                            }
                                                        />
                                                    )}
                                                </View>
                                            )}
                                        <View style={{ flex: 1 }}>
                                            {product.name && smallWindow && (
                                                <Text
                                                    style={[
                                                        styles.nameProduct,
                                                        { textAlign: 'left' },
                                                        !smallWindow
                                                            ? { fontSize: 40 }
                                                            : { marginTop: 10 },
                                                        !smallWindow &&
                                                            verticalHeader && {
                                                                textAlign: 'left',
                                                            },
                                                    ]}
                                                >
                                                    {product.name ?? ''}
                                                </Text>
                                            )}

                                            {smallWindow && (
                                                <Text
                                                    style={[
                                                        styles.dataProduct,
                                                        { paddingHorizontal: 12 },
                                                        !smallWindow && {
                                                            fontSize: 16,
                                                            alignSelf: 'center',
                                                            flex: 1,
                                                        },
                                                    ]}
                                                >
                                                    {product.ean &&
                                                        product.ean !=
                                                            'undefined' && (
                                                            <Text>
                                                                {eanPrefix +
                                                                    [
                                                                        product.ean ??
                                                                            '',
                                                                    ]}
                                                            </Text>
                                                        )}
                                                    {product.sku &&
                                                        product.sku !=
                                                            'undefined' && (
                                                            <Text>
                                                                {(!verticalInfo
                                                                    ? ' | '
                                                                    : '\n') +
                                                                    skuPrefix +
                                                                    [
                                                                        product.sku ??
                                                                            '',
                                                                    ]}
                                                            </Text>
                                                        )}
                                                </Text>
                                            )}
                                        </View>
                                    </View>
                                </View>
                                <View style={{ flex: 1 }}>
                                    {/* Name patalla grande */}
                                    {product.name && !smallWindow && (
                                        <Text
                                            style={[
                                                styles.nameProduct,
                                                { textAlign: 'left' },
                                                !smallWindow
                                                    ? { fontSize: 40 }
                                                    : { marginTop: 10 },
                                                !smallWindow &&
                                                    verticalHeader && {
                                                        textAlign: 'left',
                                                    },
                                            ]}
                                        >
                                            {product.name ?? ''}
                                        </Text>
                                    )}
                                    {!smallWindow && (
                                        <Text
                                            style={[
                                                styles.dataProduct,
                                                { paddingHorizontal: 12 },
                                                { fontSize: 15, flex: 1 },
                                            ]}
                                        >
                                            {product.ean &&
                                                product.ean != 'undefined' && (
                                                    <Text>
                                                        {eanPrefix +
                                                            [product.ean ?? '']}
                                                    </Text>
                                                )}
                                            {product.sku &&
                                                product.sku != 'undefined' && (
                                                    <Text>
                                                        {(!verticalInfo
                                                            ? ' | '
                                                            : '\n') +
                                                            skuPrefix +
                                                            [product.sku ?? '']}
                                                    </Text>
                                                )}
                                        </Text>
                                    )}
                                    {product.description_short && (
                                        <View>
                                            {product.description_short.length >
                                                60 && (
                                                <Text
                                                    style={[
                                                        styles.sectionTitle,
                                                        !smallWindow && {
                                                            fontSize: 22,
                                                            marginTop: 24,
                                                        },
                                                    ]}
                                                >
                                                    {languageFile.description}
                                                </Text>
                                            )}
                                            {product.description_short.length >
                                                60 && (
                                                <View
                                                    style={[
                                                        styles.dividerHorizontalLine,
                                                        { flex: 1, width: '98%' },
                                                    ]}
                                                ></View>
                                            )}

                                            <Text
                                                style={[
                                                    styles.descriptionProduct,
                                                    {
                                                        textAlign:
                                                            product.description_short
                                                                .length <= 60
                                                                ? 'center'
                                                                : 'left',
                                                    },
                                                    !smallWindow && {
                                                        fontSize: 16,
                                                        marginTop: 10,
                                                    },
                                                ]}
                                            >
                                                {product.description_short}
                                            </Text>
                                        </View>
                                    )}
                                    {(expoConfig.slug === 'one-pfizer' ||
                                        expoConfig.slug === 'dots') &&
                                        product.description_long && (
                                            <Text
                                                style={[
                                                    styles.descriptionProduct,
                                                    {
                                                        textAlign:
                                                            product.description_short
                                                                .length <= 60
                                                                ? 'center'
                                                                : 'left',
                                                    },
                                                ]}
                                            >
                                                {product.description_long ?? ''}
                                            </Text>
                                        )}
                                    {product.download_links &&
                                    product.download_links.length > 0 ? (
                                        <View
                                            style={!smallWindow && { marginTop: 4 }}
                                        >
                                            <Text
                                                style={[
                                                    styles.sectionTitle,
                                                    !smallWindow && {
                                                        fontSize: 22,
                                                        marginTop: 20,
                                                    },
                                                ]}
                                            >
                                                {languageFile.data_sheet}
                                            </Text>
                                            <View
                                                style={[
                                                    styles.dividerHorizontalLine,
                                                    { flex: 1 },
                                                ]}
                                            ></View>
                                            <FlatList
                                                data={product.download_links}
                                                horizontal={false}
                                                nestedScrollEnabled={true}
                                                style={{ minHeight: '20%' }}
                                                showsVerticalScrollIndicator={false}
                                                renderItem={({ item }) => (
                                                    <DownloadPdfButtom
                                                        media={item}
                                                        activeLoader={activeLoader}
                                                    />
                                                )}
                                                ItemSeparatorComponent={() => (
                                                    <View
                                                        style={[
                                                            styles.spacer,
                                                            !smallWindow && {
                                                                marginBottom: 3,
                                                            },
                                                        ]}
                                                    />
                                                )}
                                            />
                                        </View>
                                    ) : (
                                        <></>
                                    )}
                                </View>
                            </View>
                        </ScrollView>
                    </View>
                </>
            )}
        </>
    )
}

interface DownloadPdfButtomProps {
    media: DownloadLinks
    activeLoader: (boolean) => void
}
export const DownloadPdfButtom = ({
    media,
    activeLoader,
}: DownloadPdfButtomProps) => {
    const expoConfig = Constants.expoConfig || { slug: '' }

    const navigation = useNavigation()

    const webViewUrl =
        Platform.OS === 'android'
            ? `https://drive.google.com/viewerng/viewer?embedded=true&url=${media.media_url}`
            : media.media_url

    const handleTouchViewMedia = () => {
        console.log('renderizar: ', media.media_url)

        if (isWeb) {
            try {
                const urlToOpen = media.media_url
                // Abrir en nueva pestaña/ventana de manera segura
                window.open(urlToOpen, '_blank', 'noopener,noreferrer')
            } catch (err) {
                console.error('Error abriendo media en nueva pestaña', err)
            }
            return
        }

        navigation.navigate('WebView', { link: webViewUrl })
    }
    const handleTouchDownloadMedia = async () => {
        try {
            if (isWeb) {
                try {
                    const url = media.media_url
                    const getFileName = (inputUrl: string) => {
                        try {
                            const cleanUrl = inputUrl.split('?')[0]
                            const name = decodeURIComponent(
                                cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1),
                            )
                            return name || 'archivo'
                        } catch (e) {
                            return 'archivo'
                        }
                    }
                    const fileName = getFileName(url)
                    const res = await fetch(url)
                    const blob = await res.blob()
                    const blobUrl = URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = blobUrl
                    a.download = fileName
                    document.body.appendChild(a)
                    a.click()
                    document.body.removeChild(a)
                    try {
                        window.open(blobUrl, '_blank', 'noopener')
                    } catch {}
                    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000)
                } catch (error) {
                    console.error(
                        'Descarga web falló, abriendo en nueva pestaña',
                        error,
                    )
                    window.open(media.media_url, '_blank', 'noopener,noreferrer')
                }
                return
            }
            downloadPdf(media.media_url)
        } catch (error) {
            console.error('handleTouchDownloadMedia : ', error)
        } finally {
        }
    }

    // const breakPoint = useBreakpoint()
    // const isMobile = breakPoint === 'sm'
    const extension = media?.media_url?.split('?')[0].split('.').pop() || ''
    const canSee = extension === 'pdf' //Quedan por separado por si en algun momento se agregan distintos tipos
    const canDownload = extension != 'pdf'

    const save = (uri) => {
        shareAsync(uri)
    }
    const bp = useBreakpoint()
    const smallWindow = bp === 'sm'
    return (
        <View style={[styles.containerItem, !smallWindow && { flex: 1 }]}>
            <Text
                style={[styles.fileName, !smallWindow && { fontSize: 14 }]}
                numberOfLines={1}
                ellipsizeMode='tail'
            >
                {media.media_name}
            </Text>

            <View style={styles.icons}>
                {canSee && (
                    <TouchableOpacity onPress={handleTouchViewMedia}>
                        <Feather
                            name='eye'
                            size={24}
                            color={theme.colors.colorPrimary}
                            style={styles.iconButton}
                        />
                    </TouchableOpacity>
                )}
                {expoConfig.slug != 'jti-connect' && canDownload && (
                    <TouchableOpacity onPress={handleTouchDownloadMedia}>
                        <Feather
                            name='download'
                            size={24}
                            color={theme.colors.colorPrimary}
                            style={styles.iconButton}
                        />
                    </TouchableOpacity>
                )}
            </View>
        </View>
    )
}
const arrowStyle = StyleSheet.create({
    arrowButton: {
        position: 'absolute',
        top: '50%',
        transform: [{ translateY: -20 }],
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        width: 40,
        height: 40,
        borderRadius: 20,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1,
    },
})
